import React, { useContext, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import { useNavigate, useLocation } from 'react-router-dom';
import { IMAGES_URL } from 'Utils/URLs';
import { getDisplayUrl } from 'Utils/mediaUrl';
import { UserContext } from '../Hooks/UserContext';
import NotificationSection from 'Component/NotificationSection';
import { IconMenu2 } from '@tabler/icons-react';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import CarRepairIcon from "@mui/icons-material/CarRepair";
import DriveWithUsState from 'Hooks/DriveWithUs.state';
import { set } from 'react-hook-form';
import PlagiarismIcon from '@mui/icons-material/Plagiarism';

function Header({ setValue }) {
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const { user, LogoutUser, notificcations } = useContext(UserContext)
  const { GetDriveWithUs, loading, driveWithUsData } = DriveWithUsState()
  const { pathname } = useLocation()
  const navigate = useNavigate()

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  useEffect(() => {
    GetDriveWithUs(user?.token)
  }, [])


  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const handleLogout = () => {
    LogoutUser()
    navigate("/driver_forms")
  }

  function isExpired(dateString) {
    const givenDate = new Date(dateString);
    const currentDate = new Date();

    return givenDate < currentDate;
  }

  const expiredFiles = driveWithUsData.filter(
    (item) => isExpired(item.file_expiry) || item.file_status === 2
  );
  
  const expiredCount = expiredFiles.length;
  
  const isDriveTabVisible =
    user?.form_name === "drive_with_us" && expiredCount > 0;

  const tabs = [
    // {
    //   value: 3,
    //   label: "Drive With Us",
    //   icon: <i className="las la-car" />,
    //   condition:
    //     user?.form_name === "drive_with_us" &&
    //     driveWithUsData.some(
    //       (item) => isExpired(item.file_expiry) || item.file_status === 2
    //     ),
    // },
    {
      value: 3,
      label: "Partner With Us",
      icon: <i className="mdi mdi-handshake-outline" />,
      condition:
        user?.form_name === "partner_with_us"
    },
    {
      value: 3,
      label: "Get Free Ride",
      icon: <i className="mdi mdi-taxi" />,
      condition:
        user?.form_name === "free_ride"
    },
   
    {
      value: 4,
      label: "Update Car Information",
      icon: <i class="ri-car-washing-fill"></i>,
      condition: user?.form_name === "drive_with_us" && driveWithUsData.length > 0,
    },
    {
      value: 2,
      label: "Payment",
      icon: <i className="ri-bank-line -mt-5" />,
      condition: user?.status === "1",
    },
  ]

console.log(notificcations)

  return (
    <AppBar position="static" sx={{ backgroundColor: "transparent" }} elevation={0} >
      <Container maxWidth="lg">
        <Toolbar disableGutters>
          <Box sx={{ display: { xs: "flex", md: "flex" } }}>
            <a onClick={() => navigate("/driver_forms")} style={{ cursor: "pointer" }} > <img src='/driver_forms/assets/images/output-onlinepngtools.png' style={{ height: 80, width: 120, marginTop: 10 }} /></a>
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}  >
            {/* {!pathname.includes("submit") && (
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
            )} */}

          </Box>

          {/* <Typography
            variant="h5"
            noWrap
            component="a"
           
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            <a onClick={()=>navigate("/driver_forms")} style={{cursor:"pointer"}} > <img src='/driver_forms/assets/images/output-onlinepngtools.png' style={{height:80,width:120,marginTop:10}} /></a>
          </Typography> */}
          <Box sx={{ flexGrow: 2, display: { xs: 'none', md: 'flex' } }}>
            {/* {pages.map((page) => (
              <Button
                key={page}
                onClick={()=>navigate(page.route)}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {page.title}
              </Button>
            ))} */}
          </Box>

          <Box sx={{ flexGrow: 0, display: "flex", alignItems: "center" }}  >

            {!pathname.includes("submit") &&
              <Box pl={0.5} pr={1} >
                <NotificationSection />
              </Box>
            }
            {!pathname.includes("submit") &&
              <Tooltip title="Open settings">
                <Box sx={{ backgroundColor: "#FFF", p: 0, borderRadius: 50 }} >
                  <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    <Avatar sx={{ height: 45, width: 45 }} alt={user?.name} src={user?.profile_pic ? getDisplayUrl(user.profile_pic, IMAGES_URL) : ""} />
                  </IconButton>
                </Box>
              </Tooltip>
            }
            <Menu
              id="menu-appbar"
              anchorEl={anchorElUser}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
              TransitionComponent={undefined}
              PaperProps={{
                sx: {
                  mt: 6.5,
                  backgroundColor: '#021B38',
                  color: '#96c11e',
                  borderRadius: 2,
                  boxShadow: 3,
                  minWidth: 200,
                  '& .MuiMenuItem-root': {
                    gap: 1,
                    py: 1,
                    px: 2,
                    '&:hover': {
                      backgroundColor: '#021B48',
                    },
                  },
                  '& .MuiSvgIcon-root': {
                    color: '#96c11e',
                  },
                },
              }}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
              {/* Always visible on desktop */}
             
              <MenuItem className='d-none d-md-flex' onClick={() => { navigate("/driver_forms/profile"); handleCloseUserMenu(); }}>
                <PersonOutlineIcon />
                <Typography>Profile</Typography>
              </MenuItem>
             
              <MenuItem className='d-flex d-md-none' onClick={() => { navigate("/driver_forms/profile"); handleCloseUserMenu();setValue(1) }}>
                <PersonOutlineIcon />
                <Typography>Profile</Typography>
              </MenuItem>
              
              {/* <MenuItem className='d-flex ' onClick={() => { navigate("/driver_forms/edit"); handleCloseUserMenu(); }}>
                <i className="ri-edit-box-line align-bottom" />
                <Typography>Edit Profile</Typography>
              </MenuItem> */}
              {/* Tabs - shown only on mobile */}
              {tabs.map((tab) => (
                tab.condition && (
                  <MenuItem
                    className='d-flex d-md-none'
                    key={tab.label}
                    onClick={() => {
                      setValue(tab.value);
                      handleCloseUserMenu();
                      if (pathname.includes("edit")) {
                        navigate("/driver_forms/profile");
                      }
                    }}
                  >
                    {tab.icon}
                    <Typography>{tab.label}</Typography>
                  </MenuItem>
                )
              ))}
              {isDriveTabVisible && (
              <MenuItem className='d-flex d-md-none' onClick={() => { setValue(3); handleCloseUserMenu(); }}>
                <PlagiarismIcon />
                <Typography>Expired Documents</Typography>
              </MenuItem>
              )}

              {/* Edit Profile - show only on mobile below profile/account */}
             

              {/* Log out - always at the bottom */}
              <MenuItem onClick={handleLogout}>
                <LogoutOutlinedIcon />
                <Typography>Log out</Typography>
              </MenuItem>
            </Menu>

          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default Header;
